import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';
import {
  orgSnowflakeConnectionUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';
import type { SnowflakeConnectionResponse } from '@/lib/portfolio/snowflake-types';

export function useSnowflakeConnection(orgId: number) {
  return useQuery<SnowflakeConnectionResponse>({
    queryKey: portfolioQueryKeys.orgSnowflakeConnection(orgId),
    queryFn: () =>
      apiGet<SnowflakeConnectionResponse>(orgSnowflakeConnectionUrl(orgId)),
    staleTime: 30_000,
    enabled: !!orgId,
  });
}
